import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledTranslateContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .language-selectors {
    display: flex;
    gap: 16px;

    .language-selector {
      width: 224px;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .input-label {
        font-family: 'SF Pro Text', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: ${COLOR.darkGray};
      }

      .dropdown-container {
        height: 40px;
        border-radius: 8px;
      }

      .dropdown-error .dropdown-container {
        border: 1px solid ${COLOR.functionalRed.default};
      }

      .error-message {
        margin-top: 4px;
        font-family: 'SF Pro Text', sans-serif;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .tip-container {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 12px;
    background-color: ${COLOR.bluev2[8]};
    border-radius: 8px;

    .tip-icon {
      color: ${COLOR.bluev2[100]};
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .tip-text {
      color: ${COLOR.label2[100]};
      font-family: 'SF Pro Text', sans-serif;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const StyledTranslateActions = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;

  .credit-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    background-color: ${COLOR.warning[8]};
    border-radius: 4px;
    font-size: 12px;
    color: ${COLOR.warning[100]};
  }
`;
